<template>
  <Follow></Follow>
  <OptionCards2></OptionCards2>
  <hr class="section-separator" v-if="themeInfo.info?.employers.length > 1" />
  <section v-if="themeInfo.info?.employers.length > 1">
    <div class="title-and-more">
      <h2>اعضاء</h2>
      <router-link class="more" :to="'/' + token + '/members'"
        >دیدن همه...</router-link
      >
    </div>
    <div class="other-members">
      <AvatarCircleBOX
        :token="token"
        :employer="newEmployer"
        v-if="managerMode == 'dataEdit'"
      ></AvatarCircleBOX>
      <template
        v-for="(member, index) in themeInfo.info?.employers.slice(0, 3)"
        :key="index"
      >
        <AvatarCircleBOX :token="token" :employer="member"></AvatarCircleBOX>
      </template>
    </div>
  </section>
  <hr
    class="section-separator"
    v-if="
      themeInfo?.info?.imageGallery.filter((el) => {
        return el.showIn == 'slider';
      }).length > 0
    "
  />
  <section
    class="seller-banner-section"
    v-if="
      themeInfo?.info?.imageGallery.filter((el) => {
        return el.showIn == 'slider';
      }).length > 0
    "
  >
    <div class="title-and-more">
      <h2>تصاویر محیطی</h2>
      <router-link class="more" :to="'/' + token + '/gallery'"
        >سایر تصاویر...</router-link
      >
    </div>
    <videoBanner
      :videoObj="themeInfo.info?.videoBanners?.homePageSlider"
      :displayStyle="'homePageSlider'"
      v-if="themeInfo.info?.videoBanners?.homePageSlider"
    />
    <SellerBanner :pageName="'showInHomePage'" v-else />
  </section>

  <hr class="section-separator" v-if="themeInfo.info?.products.length > 0" />
  <section class="products-section" v-if="themeInfo.info?.products.length > 0">
    <div class="title-and-more">
      <h2>محصولات / خدمات</h2>
      <router-link
        class="more"
        :to="'/' + token + '/products'"
        v-if="themeInfo.info?.products.length > 5"
        >دیدن همه...</router-link
      >
    </div>

    <ProductCard
      :key="0"
      :product="newProduct"
      v-if="managerMode == 'dataEdit'"
    >
    </ProductCard>

    <ProductCard
      v-for="(product, index) in themeInfo.info?.products.slice(0, 5)"
      :key="index + 1"
      :product="product"
    >
    </ProductCard>
  </section>
  <SocialLink></SocialLink>
</template>

<script>
import Follow from "@/components/follow/index.vue";
import OptionCards2 from "@/components/OptionCards2/index.vue";
import AvatarCircleBOX from "@/components/AvatarCircleBOX/index.vue";
import SellerBanner from "@/components/SellerBanner/index.vue";
import videoBanner from "@/components/videoBanner/index.vue";
import ProductCard from "@/components/ProductCard/index.vue";
import SocialLink from "@/components/socialLink/index.vue";
import { membersData } from "@/repo/membersData";
import { productsData } from "@/repo/productsData";
import { sellerData } from "@/repo/sellerData.js";
import { mapGetters } from "vuex";
import { publicHelpers } from "@/public/helpers";

export default {
  name: "HomePage",
  mixins: [membersData, productsData, sellerData, publicHelpers],
  components: {
    Follow,
    OptionCards2,
    ProductCard,
    AvatarCircleBOX,
    SocialLink,
    SellerBanner,
    videoBanner,
  },

  data() {
    return {
      token: null,
    };
  },
  async mounted() {
    await this.$nextTick();
    this.token = this.$route.params.token;
  },

  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
      managerMode: "managerMode",
    }),
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/pages/home/home.css);
</style>